{
  "toasts": {
    "created": "¡Plantilla creada correctamente!",
    "createError": "Error al crear la plantilla",
    "restored": "Plantilla restablecida a la predeterminada",
    "restoreError": "Error al restablecer la plantilla",
    "updated": "¡Plantilla actualizada correctamente!",
    "updateError": "Error al actualizar la plantilla",
    "saveError": "Error al guardar la plantilla"
  },
  "page": {
    "title": "Plantillas de email",
    "subtitle": "Configura los emails que se envían automáticamente en cada evento de la plataforma"
  },
  "categories": {
    "authentication": "Autenticación",
    "enrollments": "Inscripciones",
    "progress": "Progreso",
    "payments": "Pagos",
    "community": "Comunidad",
    "gamification": "Gamificación",
    "allWithCount": "Todos ({{count}})",
    "withCount": "{{label}} ({{count}})"
  },
  "stats": {
    "mappedEvents": "Eventos mapeados",
    "createdTemplates": "Plantillas creadas",
    "active": "Activas",
    "inactive": "Inactivas"
  },
  "status": {
    "active": "Activa",
    "inactive": "Inactiva",
    "noTemplate": "Sin plantilla",
    "toggleAllLanguages": "Activa o desactiva la plantilla en todos los idiomas"
  },
  "actions": {
    "edit": "Editar",
    "createTemplate": "Crear plantilla",
    "cancel": "Cancelar",
    "save": "Guardar"
  },
  "reset": {
    "title": "Restablecer plantilla",
    "description": "El asunto y el contenido en {{language}} vuelven al predeterminado de la plataforma. Se perderán los cambios hechos en este idioma.",
    "confirm": "Restablecer"
  },
  "logo": {
    "alt": "Logo",
    "title": "Logo de los emails",
    "descriptionWithLogo": "Se muestra automáticamente en la parte superior de todas las plantillas.",
    "descriptionEmpty": "Sube un logo para mostrarlo en todos los emails (PNG, JPG o SVG, hasta 2 MB).",
    "remove": "Eliminar",
    "replace": "Sustituir",
    "upload": "Subir logo"
  },
  "editor": {
    "fallbackTitle": "Plantilla",
    "createTitle": "Crear: {{title}}",
    "editTitle": "Editar: {{title}}",
    "subject": "Asunto del email",
    "subjectPlaceholder": "Asunto del email con {{open}}variables{{close}}",
    "variables": "Variables disponibles",
    "variablesHint": "(haz clic para insertarla en el editor)",
    "preview": "Vista previa",
    "from": "De:",
    "to": "Para:",
    "subjectLabel": "Asunto:",
    "previewFrameTitle": "Vista previa del email",
    "newLanguage": "Nuevo",
    "unsavedChanges": "Cambios sin guardar",
    "missingLanguage": "Este idioma aún no tiene plantilla. El contenido de abajo es el predeterminado de la plataforma y se creará al guardar."
  },
  "languages": {
    "label": "Idiomas de la plantilla",
    "available": "{{language}}: creada",
    "missing": "{{language}}: aún no creada"
  },
  "eventCatalog": {
    "first-access": {
      "name": "Usuario creado",
      "description": "Se envía cuando se crea un nuevo usuario. Da la bienvenida o envía las credenciales de primer acceso."
    },
    "user-updated": {
      "name": "Usuario actualizado",
      "description": "Se envía cuando cambian los datos del perfil del usuario (p. ej.: email, nombre)."
    },
    "password-reset": {
      "name": "Restablecimiento de contraseña",
      "description": "Se envía cuando el usuario o un administrador solicita restablecer la contraseña. Incluye un enlace para definir una nueva."
    },
    "login-new-device": {
      "name": "Inicio de sesión en un nuevo dispositivo",
      "description": "Alerta de seguridad que se envía cuando el usuario inicia sesión en un dispositivo o navegador nuevo."
    },
    "enrollment-confirmation": {
      "name": "Inscripción creada",
      "description": "Se envía cuando el usuario se inscribe en un curso (compra, administrador o grupo de acceso)."
    },
    "enrollment-removed": {
      "name": "Inscripción eliminada",
      "description": "Se envía cuando la inscripción de un usuario se cancela o caduca."
    },
    "enrollment-expiring": {
      "name": "Inscripción a punto de caducar",
      "description": "Se envía cuando faltan pocos días para que caduque la inscripción del alumno. Ideal para renovaciones."
    },
    "enrollment-expired": {
      "name": "Inscripción vencida",
      "description": "Se envía cuando la inscripción del alumno expiró y se retiró el acceso."
    },
    "lesson-added": {
      "name": "Clase añadida",
      "description": "Se envía cuando se publica una nueva clase. Avisa a todos los alumnos inscritos en el curso."
    },
    "lesson-completed": {
      "name": "Clase completada",
      "description": "Se envía cuando el alumno completa una clase. Ideal para felicitar su progreso."
    },
    "module-completed": {
      "name": "Módulo completado",
      "description": "Se envía cuando el alumno completa todas las clases de un módulo del curso."
    },
    "course-completed": {
      "name": "Curso completado",
      "description": "Se envía cuando el alumno completa el 100 % de las clases de un curso. ¡Momento de celebrar!"
    },
    "certificate-issued": {
      "name": "Certificado emitido",
      "description": "Se envía cuando se genera un certificado de finalización para el alumno."
    },
    "inactivity-reminder": {
      "name": "Recordatorio de inactividad",
      "description": "Reenganche: se envía cuando el alumno lleva X días sin entrar en la plataforma."
    },
    "payment-confirmed": {
      "name": "Pago aprobado",
      "description": "Se envía cuando se confirma un pago. Incluye la confirmación y el acceso al contenido."
    },
    "payment-refunded": {
      "name": "Pago reembolsado",
      "description": "Se envía cuando se procesa un reembolso. Informa al usuario de la devolución."
    },
    "comment-reply": {
      "name": "Respuesta a un comentario",
      "description": "Se envía cuando alguien responde al comentario del usuario en una clase."
    },
    "comment-reaction": {
      "name": "Reacción a un comentario",
      "description": "Se envía cuando alguien reacciona al comentario del usuario (me gusta, etc.)."
    },
    "comment-mention": {
      "name": "Mención en un comentario",
      "description": "Se envía cuando alguien menciona al usuario (@nombre) en un comentario o respuesta."
    },
    "points-earned": {
      "name": "Puntos conseguidos",
      "description": "Se envía cuando el usuario gana XP al completar acciones. Muy frecuente: desactivado por defecto."
    },
    "level-up": {
      "name": "Subida de nivel",
      "description": "Se envía cuando el usuario sube de nivel en la gamificación. ¡Momento de celebrar!"
    },
    "badge-earned": {
      "name": "Logro desbloqueado",
      "description": "Se envía cuando el usuario consigue una nueva insignia o trofeo en la plataforma."
    },
    "weekly-report": {
      "name": "Informe semanal",
      "description": "Resumen semanal del progreso del alumno: clases vistas, XP ganados y posición en el ranking."
    }
  }
}
